export default __webpack_public_path__ + "static/spot-illos-dark-18cd463a7e08b4fc8f69db203bfd4ed6.png";